(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[171],{

/***/ "VBBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextSeeMore; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NPTU");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var TextSeeMore = function TextSeeMore(_ref) {
  var className = _ref.className,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'TextSeeMore' : _ref$dataTestIdPrefix,
      hasNoScrollOnCollapse = _ref.hasNoScrollOnCollapse,
      isCollapseEnabled = _ref.isCollapseEnabled,
      offsetScrollSelector = _ref.offsetScrollSelector,
      onClick = _ref.onClick,
      seeMoreColor = _ref.seeMoreColor,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreSize = _ref.seeMoreSize,
      textProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "dataTestIdPrefix", "hasNoScrollOnCollapse", "isCollapseEnabled", "offsetScrollSelector", "onClick", "seeMoreColor", "seeLessLabel", "seeMoreLabel", "seeMoreSize"]);

  return __jsx(_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__[/* SeeMore */ "a"], {
    className: className,
    color: seeMoreColor,
    hasNoScrollOnCollapse: hasNoScrollOnCollapse,
    isCollapseEnabled: isCollapseEnabled,
    offsetScrollSelector: offsetScrollSelector,
    onClick: onClick,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize
  }, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_4__[/* Text */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, textProps, {
    dataTestId: "".concat(dataTestIdPrefix, "-text")
  })));
};

/***/ }),

/***/ "aMVx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/introduction/Introduction.jsx + 1 modules
var Introduction = __webpack_require__("pNXd");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/lines/title-and-text-line/TitleAndTextLine.jsx
var __jsx = react_default.a.createElement;




var TitleAndTextLine_TitleAndTextLine = function TitleAndTextLine(_ref) {
  var config = _ref.config,
      hasShadow = _ref.hasShadow,
      icon = _ref.icon,
      id = _ref.id,
      smallTitle = _ref.smallTitle,
      subTitle = _ref.subTitle,
      text = _ref.text,
      title = _ref.title;
  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: classnames_default()('Line', {
      'border-b-1 border-t-1 border-lightGrey Line-Introduction shadow-md': hasShadow,
      'Line-TitleAndText': !hasShadow
    }),
    id: id
  }, __jsx(Introduction["a" /* Introduction */], {
    className: hasShadow ? 'py-20' : '',
    iconName: icon,
    isTextSeeMoreCollapseEnabled: true,
    small: smallTitle,
    seeMoreLabel: config.common.viewMore,
    seeLessLabel: config.common.loadLess,
    subtitle: subTitle,
    text: text,
    title: title
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/title-and-text/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (TitleAndTextLine_TitleAndTextLine);

/***/ }),

/***/ "pNXd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Introduction_Introduction; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("uFXj");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/introduction/Introduction.themes.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(defineProperty["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var defaultTheme = {
  thRoot: 'flex flex-col sm:flex-row gap-20 overflow-hidden',
  thLeft: 'flex-1',
  thRight: 'flex-1',
  thTitleTheme: 'title-brand-n1',
  thSmall: 'font-sans lowercase text-14',
  thSubtitleTheme: 'title-sans-n2',
  thSubtitleColor: colors["a" /* COLORS */].SIENNA
};
var themes = {
  "default": defaultTheme,
  column: _objectSpread(_objectSpread({}, defaultTheme), {}, {
    thRoot: 'flex flex-col gap-20 overflow-hidden',
    thLeft: 'flex flex-col items-center justify-center',
    thRight: 'flex justify-center'
  })
};
// CONCATENATED MODULE: ./src/client/components/frameworks/introduction/Introduction.jsx

var __jsx = react_default.a.createElement;





var Introduction_Introduction = function Introduction(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      iconName = _ref.iconName,
      isTextSeeMoreCollapseEnabled = _ref.isTextSeeMoreCollapseEnabled,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      small = _ref.small,
      subtitle = _ref.subtitle,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;
  var hasHeading = !!title || !!subtitle;
  var hasText = !!text;

  if (!hasHeading && !hasText) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLeft = _themes$theme.thLeft,
      thRight = _themes$theme.thRight,
      thRoot = _themes$theme.thRoot,
      thSmall = _themes$theme.thSmall,
      thSubtitleColor = _themes$theme.thSubtitleColor,
      thSubtitleTheme = _themes$theme.thSubtitleTheme,
      thTitleTheme = _themes$theme.thTitleTheme;
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    "data-testid": dataTestId
  }, hasHeading && __jsx("div", {
    className: thLeft
  }, __jsx(Title["a" /* Title */], {
    hLevel: 2,
    iconName: iconName,
    theme: thTitleTheme
  }, title, !!small && __jsx("small", {
    className: thSmall
  }, small)), __jsx(Title["a" /* Title */], {
    color: thSubtitleColor,
    hLevel: 3,
    theme: thSubtitleTheme
  }, subtitle)), hasText && __jsx("div", {
    className: thRight
  }, __jsx(TextSeeMore["a" /* TextSeeMore */], {
    isCollapseEnabled: isTextSeeMoreCollapseEnabled,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    text: text
  })));
};

/***/ }),

/***/ "uFXj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var createHTML = __webpack_require__("gIHd");
var forcedStringHTMLMethod = __webpack_require__("sHxg");

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ })

}]);